import { render } from "./wool.vue?vue&type=template&id=ada27db6&scoped=true&ts=true"
import script from "./wool.vue?vue&type=script&lang=ts"
export * from "./wool.vue?vue&type=script&lang=ts"

import "./wool.vue?vue&type=style&index=0&id=ada27db6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada27db6"]])

export default __exports__